import React, { useState, useEffect } from 'react';

const WHATSAPP_NUMBER = '15557696610';
const PRE_FILLED_MESSAGE = "Hi, I'd like to know more about Desi Firms platform";

const WhatsAppButton = () => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    // Show tooltip after 3 seconds, auto-hide after 8 seconds
    useEffect(() => {
        const showTimer = setTimeout(() => setShowTooltip(true), 3000);
        const hideTimer = setTimeout(() => setShowTooltip(false), 11000);
        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, []);

    const handleClick = () => {
        setDismissed(true);
        setShowTooltip(false);
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PRE_FILLED_MESSAGE)}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <>
            <style>{`
                .wa-float-btn {
                    position: fixed;
                    bottom: 24px;
                    left: 24px;
                    z-index: 9998;
                    display: flex;
                    align-items: center;
                    gap: 0;
                    cursor: pointer;
                    filter: drop-shadow(0 4px 12px rgba(37, 211, 102, 0.4));
                    transition: transform 0.2s, filter 0.2s;
                }
                .wa-float-btn:hover {
                    transform: scale(1.08);
                    filter: drop-shadow(0 6px 20px rgba(37, 211, 102, 0.5));
                }
                .wa-float-icon {
                    width: 56px;
                    height: 56px;
                    background: #25D366;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                .wa-float-icon svg {
                    width: 30px;
                    height: 30px;
                    fill: white;
                }
                .wa-tooltip {
                    position: absolute;
                    left: 68px;
                    bottom: 8px;
                    background: white;
                    color: #111;
                    padding: 10px 16px;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 500;
                    white-space: nowrap;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
                    opacity: 0;
                    transform: translateX(-8px);
                    animation: waTooltipIn 0.3s ease forwards;
                    pointer-events: none;
                    line-height: 1.3;
                }
                .wa-tooltip::before {
                    content: '';
                    position: absolute;
                    left: -6px;
                    bottom: 14px;
                    width: 12px;
                    height: 12px;
                    background: white;
                    transform: rotate(45deg);
                    box-shadow: -2px 2px 4px rgba(0,0,0,0.05);
                }
                .wa-tooltip-hide {
                    animation: waTooltipOut 0.3s ease forwards !important;
                }
                @keyframes waTooltipIn {
                    to { opacity: 1; transform: translateX(0); }
                }
                @keyframes waTooltipOut {
                    from { opacity: 1; transform: translateX(0); }
                    to { opacity: 0; transform: translateX(-8px); }
                }
                @keyframes waPulse {
                    0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4); }
                    50% { box-shadow: 0 0 0 12px rgba(37, 211, 102, 0); }
                }
                .wa-float-icon-pulse {
                    animation: waPulse 2s ease infinite;
                }
                @media (max-width: 480px) {
                    .wa-float-btn { bottom: 16px; left: 16px; }
                    .wa-float-icon { width: 50px; height: 50px; }
                    .wa-float-icon svg { width: 26px; height: 26px; }
                    .wa-tooltip { font-size: 12px; left: 60px; }
                }
            `}</style>
            <div className="wa-float-btn" onClick={handleClick} role="button" aria-label="Chat on WhatsApp">
                <div className={`wa-float-icon ${!dismissed ? 'wa-float-icon-pulse' : ''}`}>
                    <svg viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                </div>
                {showTooltip && !dismissed && (
                    <div className="wa-tooltip">
                        Chat with us on WhatsApp
                    </div>
                )}
            </div>
        </>
    );
};

export default WhatsAppButton;
